module.exports = __webpack_public_path__ + "img/1.c0259927.svg";